// extracted by mini-css-extract-plugin
export default {"mainPreloader":"MainPreloader_mainPreloader__bb4HU","image":"MainPreloader_image__Y7GYz"};